import { useState } from 'react';
import * as React from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  id: string;
  index: number;
  activeTab: number;
}

const TabContent = (props: TabPanelProps) => {
  const { children, id, index, activeTab } = props;

  return activeTab === index ? (
    <div
      role='tabpanel'
      id={id}
      aria-labelledby={`tab_${index}`}
      className='h-full py-4'
    >
      {children}
    </div>
  ) : (
    <></>
  );
};

interface TabSelectorProps {
  children?: JSX.Element[];
  tabHeaders: { title: string; count?: number }[];
}

export const TabSelector = ({ children, tabHeaders }: TabSelectorProps) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className='w-full h-[95%] pt-10'>
      <div
        className='flex w-full items-center border-gray-light border-b gap-10 cursor-pointer'
        role='tablist'
      >
        {tabHeaders.map((header, index) => {
          const tabId = `tab_${index}`;
          return (
            <div
              data-test-id={tabHeaders[index].title}
              onClick={() => setActiveTab(index)}
              key={index}
              id={tabId}
              role='tab'
              aria-selected={activeTab === index}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  setActiveTab(index);
                }
              }}
              tabIndex={0}
              className={`text-dark-header border-b-2 flex items-center pb-1 text-sm ${
                activeTab === index
                  ? 'border-b-orange-normal'
                  : 'border-b-transparent'
              }`}
            >
              {header.title}
              {header.count && header.count > 0 ? (
                <div className='ml-2 w-[20px] h-[20px] bg-orange-light rounded-full text-[10px] flex items-center justify-center'>
                  {header.count}
                </div>
              ) : (
                <></>
              )}
            </div>
          );
        })}
      </div>

      {children?.map((element, index) => {
        const tabId = `tab_${index}`;
        return (
          <TabContent
            key={tabId}
            id={tabId}
            index={index}
            activeTab={activeTab}
          >
            {element}
          </TabContent>
        );
      })}
    </div>
  );
};
